// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Image
import eparoxosIcon from "assets/images/custom/eparoxos-navbar.png";
import AuthLayout from "views/layouts/AuthLayout";
import { useState } from "react";

import ApiService from "services/ApiService";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

function VerifyInvoice() {
  const [mark, setMark] = useState("");
  const [markError, setMarkError] = useState(false);
  const [uid, setUid] = useState("");
  const [uidError, setUidError] = useState(false);

  const handleMarkChange = (e) => {
    setMarkError(false);
    setMark(e.target.value);
  };
  const handleUidChange = (e) => {
    setUidError(false);
    setUid(e.target.value);
  };

  const handleSearch = async () => {
    if (mark === "") {
      setMarkError(true);
      return;
    }

    if (uid === "") {
      setUidError(true);
      return;
    }

    const response = await ApiService.getData(
      `/api/v1/invoices/exists/${uid.toUpperCase()}/${mark}`,
      {}
    );

    if (!response) {
      Swal.fire({
        icon: "error",
        title: "Άκυρο Παραστατικό!",
        text: "Παρακαλώ ελέγξτε την ορθότητα των στοιχείων του παραστατικού και προσπαθήστε ξανά.",
        showCancelButton: false,
        confirmButtonText: "OK",
      });
      return;
    }

    Swal.fire({
      icon: "success",
      title: "Έγκυρο Παραστατικό!",
      text: "Θέλετε να προχωρήσετε σε προβολή παραστατικού?",
      showCancelButton: true,
      confirmButtonText: "ΝΑΙ",
      cancelButtonText: "ΟΧΙ",
    }).then((result) => {
      if (!result.isConfirmed) return;
      const host = window.location.href.replace("/verify-invoice", "");
      const invoceUrl = `${host}/view-invoice/${uid}`;
      window.open(invoceUrl);
    });
  };

  return (
    <AuthLayout
      title="Έλεγχος Παραστατικού"
      description="Επαληθεύστε την εγκυρότητα του παραστατικού σας, πληκτρολογόντας τα στοιχεία που σας ζητούνται."
      illustration={{
        image: eparoxosIcon,
      }}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftInput
            type="text"
            placeholder="Μοναδικός Αριθμός Καταχώρησης (Μ.ΑΡ.Κ.)"
            size="large"
            error={markError}
            onChange={handleMarkChange}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            type="text"
            placeholder="Αναγωριστικό Παραστατικού (UID)"
            size="large"
            error={uidError}
            onChange={handleUidChange}
          />
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton variant="gradient" color="info" size="large" onClick={handleSearch} fullWidth>
            ΑΝΑΖΗΤΗΣΗ
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </AuthLayout>
  );
}

export default VerifyInvoice;
